import { TypeComponentNoti } from "@/enums/enums";
import { i18n } from "@/i18n";
import store from "@/store/index";

const maxFileSize = 10;
const maxFileCountDefault = 10;
const fileTypeList = [
  ".pdf",
  ".png",
  ".jpg",
  ".gif",
  ".txt",
  ".mp4",
  ".mov",
  ".csv",
  ".xlsx",
  ".docx",
  ".zip",
  ".rar",
  ".7z",
  ".jpeg",
  ".pptx",
  ".key",
  ".rdx",
  ".heic",
  ".heif",
];

export function ReadFileAsync(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      resolve(e.target.result);
    };
    reader.readAsDataURL(file);
  });
}

async function ValidateTrueImage(file: File, nameFileType: string) {
  if (nameFileType == ".png" || nameFileType == ".jpg" || nameFileType == ".jpeg") {
    const rawString = await ReadFileAsync(file);
    const image: any = new Image();
    image.src = rawString;
    return await new Promise((resolve) => {
      image.onload = function() {
        if (image.height === 0 || image.width === 0) {
          resolve(false);
        }
        resolve(true);
      };
      image.onerror = () => {
        resolve(false);
      };
    });
  } else {
    return true;
  }
}

export async function ValidateUploadFile(
  file: File,
  fileType: string,
  fileList: any,
  fileCount: any,
  maxFileCount: number = maxFileCountDefault,
  allowedFileTypeList: Array<string> | null = null
) {
  const fileName = file.name;
  const fileTypeValidateList = allowedFileTypeList ? allowedFileTypeList : fileTypeList;

  if (fileName.length > 0) {
    let validateFileType = false;
    let nameFileType = "";
    let validateFileImage: any = true;
    for (let j = 0; j < fileTypeValidateList.length; j++) {
      const fileType = fileTypeValidateList[j];
      if (fileName.substr(fileName.length - fileType.length, fileType.length).toLowerCase() == fileType.toLowerCase()) {
        nameFileType = fileType.toLowerCase();
        validateFileType = true;
        break;
      }
    }

    if (!validateFileType) {
      store.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("Validate_Upload_File_Type", {
            filename: fileName,
            fileTypeList: fileTypeValidateList.join(", "),
          }),
          typeMessage: TypeComponentNoti.error,
        },
        { root: true }
      );
      return false;
    } else {
      validateFileImage = await ValidateTrueImage(file, nameFileType);
    }

    if (!validateFileImage) {
      store.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("Validate_Upload_File_True_Image"),
          typeMessage: TypeComponentNoti.error,
        },
        { root: true }
      );
      return false;
    }
  }

  if (file.size / 1024 / 1024 > maxFileSize) {
    store.dispatch(
      "Alert/SetAlertMessage",
      {
        alertMessage: i18n.t("Validate_Upload_File_larger", { maxFileSize: maxFileSize }),
        typeMessage: TypeComponentNoti.error,
      },
      { root: true }
    );
    return false;
  }

  if (fileCount > maxFileCount) {
    store.dispatch("Alert/SetAlertMessage", {
      alertMessage: i18n.t("Validate_Upload_File_Count", { maxFileCount: maxFileCount }),
      typeMessage: TypeComponentNoti.error,
    });
    return false;
  }

  if (fileList.some((fileItem: any) => fileItem.fileName === file.name)) {
    store.dispatch("Alert/SetAlertMessage", {
      alertMessage: i18n.t("Validate_Upload_File_duplicate"),
      typeMessage: TypeComponentNoti.error,
    });
    return false;
  }

  if (file.size === 0) {
    store.dispatch("Alert/SetAlertMessage", {
      alertMessage: i18n.t("Upload_Fail_No_Content"),
      typeMessage: TypeComponentNoti.error,
    });
    return false;
  }

  return true;
}

export function ValidFilesSizeUpload(fileSize: number, totalFilesSize: number) {
  if (totalFilesSize - fileSize < 0) {
    store.dispatch(
      "Alert/SetAlertMessage",
      {
        alertMessage: i18n.t("Validate_Upload_Total_Files_larger", { maxFileSize: maxFileSize }),
        typeMessage: TypeComponentNoti.error,
      },
      { root: true }
    );
    return false;
  }
  return true;
}

export function SetAlertAddFileStorage(
  responseList: Array<any>,
  isSuccess: boolean,
  idNoificition: number,
  input: any
) {
  if (isSuccess) {
    store.dispatch(
      "Alert/SetAlertMessage",
      {
        id: idNoificition,
        typeUpload: "End",
        alertMessage: i18n.t(
          "Upload_Success",
          input.fileList.length > 1 ? { msg: " " + responseList.length + " " } : { msg: input.fileList[0].fileName }
        ),
        typeMessage: TypeComponentNoti.Success,
      },
      { root: true }
    );
  } else {
    store.dispatch(
      "Alert/SetAlertMessage",
      {
        id: idNoificition,
        typeUpload: "End",

        alertMessage: i18n.t("Upload_Fail", { msg: " " + responseList.length + " " }),
        typeMessage: TypeComponentNoti.Error,
      },
      { root: true }
    );
  }
}
